import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft, ArrowRight, Newspaper, Building2, Camera, Megaphone } from 'lucide-react';

const SECTIONS = [
  {
    slug: 'hq-events',
    title: 'HQ Events',
    subtitle: "Flagship events run by EWRF's Kuala Lumpur headquarters — Charity Golf, Symposiums, Fundraisers.",
    Icon: Building2,
    accent: 'from-blue-500 to-cyan-500',
  },
  {
    slug: 'branch-activities',
    title: 'Branch Activities',
    subtitle: 'What our branches across Malaysia are running this month — L4J classes, community drives, workshops.',
    Icon: Newspaper,
    accent: 'from-emerald-500 to-teal-500',
  },
  {
    slug: 'media-coverage',
    title: 'Media Coverage',
    subtitle: "Press articles and broadcast features covering EWRF's work in Malaysian and international media.",
    Icon: Camera,
    accent: 'from-amber-500 to-orange-500',
  },
  {
    slug: 'media-statement',
    title: 'News Releases',
    subtitle: 'Official statements and press releases from EWRF leadership on issues of public interest.',
    Icon: Megaphone,
    accent: 'from-rose-500 to-pink-500',
  },
];

const NewsIndexPage = () => (
  <div className="min-h-screen bg-gradient-to-b from-white via-amber-50/30 to-white" data-testid="news-index-page">
    <Header />

    <div className="max-w-7xl mx-auto px-4 pt-6">
      <Link to="/" className="inline-flex items-center gap-2 text-[#1565C0] hover:text-orange-600 text-sm font-bold">
        <ArrowLeft className="w-4 h-4" /> Back to Home
      </Link>
    </div>

    <section className="max-w-7xl mx-auto px-4 py-14 md:py-20">
      <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
        <div className="inline-flex items-center gap-2 mb-4">
          <span className="h-[2px] w-8 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full" />
          <span className="text-[11px] uppercase tracking-[0.2em] text-amber-700 font-bold">Stay Informed</span>
          <span className="h-[2px] w-8 bg-gradient-to-r from-orange-500 to-amber-400 rounded-full" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#0A1628] leading-[1.05]">
          News &amp;{' '}
          <span className="italic bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 bg-clip-text text-transparent">
            Events
          </span>
        </h1>
        <p className="mt-4 text-base md:text-lg text-gray-600">
          Everything happening across the EWRF nationwide movement &mdash; events, activities, press coverage,
          and official statements. Pick a section below to explore.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {SECTIONS.map(({ slug, title, subtitle, Icon, accent }) => (
          <Link
            key={slug}
            to={`/news/${slug}`}
            className="group relative rounded-3xl overflow-hidden bg-white border-2 border-gray-100 hover:border-transparent shadow-md hover:shadow-2xl transition-all p-7 md:p-8"
            data-testid={`news-section-${slug}`}
          >
            <div className={`absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b ${accent}`} />
            <div className="flex items-start gap-5">
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${accent} flex items-center justify-center text-white shadow-lg flex-shrink-0 group-hover:scale-110 group-hover:rotate-3 transition-transform`}>
                <Icon className="w-7 h-7" />
              </div>
              <div className="min-w-0 flex-1">
                <h2 className="text-xl md:text-2xl font-bold text-[#0A1628] mb-2">{title}</h2>
                <p className="text-sm text-gray-600 leading-relaxed">{subtitle}</p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-[#1565C0] font-bold text-sm group-hover:text-orange-600 transition-colors">
                  Browse {title.toLowerCase()} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>

    <Footer />
  </div>
);

export default NewsIndexPage;
